import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { BrowserRouter as Router, Route, Routes, Redirect } from "react-router-dom";
import { Layout } from "antd";

import Admin from "./Admin"

import FindMatches from "./FindMatches"

import DataCollection from "./DataCollection"

import LabelResearchers from "./LabelResearchers"

import { firebase_auth } from "./utils/database";
// import { loginUserAction, logoutUserAction } from "./redux/reducers/authReducer";

const AppRouter = () => {
    const [init, setInit] = useState(true);
    const [loggedIn, setLoggedIn] = useState(false);
    const dispatch = useDispatch();

    

    // const handleLogin = async (acmUsername) => {
    //     // create account
    //     let data = await firebase_auth.createUserWithEmailAndPassword(`${acmUsername}@who2chat.org`, "p@ssword").then(function(result) {
    //         // result.user.tenantId should be ‘TENANT_PROJECT_ID’.
    //       }).catch(function(error) {
    //         // Handle error.
    //         firebase_auth.signInWithEmailAndPassword(`${acmUsername}@who2chat.org`, "p@ssword")
    //     });
    // }

    
    useEffect(() => {
        // enforce https
        firebase_auth.signInAnonymously()
        .then(() => {
          // Signed in..
          setLoggedIn(true);
        })
        .catch((error) => {
          var errorCode = error.code;
          var errorMessage = error.message;
          // ...
        });

        // const acmUsername = getUrlParameter("username");
            
        // firebase_auth.onAuthStateChanged((user) => {
        //     if (user !== null) {
        //         dispatch(loginUserAction(user));
        //         setLoggedIn(true);
        //     }
        //     else {
        //         dispatch(logoutUserAction());
        //         setLoggedIn(false);

        //         // this will be triggered when users try to authenticate with ACM without gmail
        //         //  check username param if exist, then create with email & password user or login
        //         if(acmUsername) {
        //             if(acmUsername == "undefined")
        //                 alert("Sorry there was an error logging into your ACM account. Please try again");
        //             else
        //                 handleLogin(acmUsername);
        //         }
        //     }
        //     setInit(true);

            
        // })
    }, [dispatch])
    return (
        <Router>
            <Routes>
                {loggedIn ?
                <Route path="/" element={<DataCollection />} />:
                <Route path="/" element={<span>Loading..</span>} />
                }
                <Route path="/survey" element={<FindMatches />} />
                <Route path="/label" element={<LabelResearchers />} />
                <Route path="/admin_soya" element={<Admin />} />
            {/* <Route exact path="/">
                                    <DataCollection />
                                </Route>
                                <Route exact path="/survey">
                                    <FindMatches />
                                </Route> */}
            </Routes>
        </Router>
    )

}

export default AppRouter;
